import { TweenMax, TimelineMax, Power1 } from 'gsap';
import PointerEvents from '../../../vendor_core/core/src/const/PointerEvents';
import SoundVars from '../../../vendor_core/core/src/const/SoundVars';
import BetModel from '../../../vendor_core/core/src/model/BetModel';
import BuyFeatureModel from '../../../vendor_core/core/src/model/BuyFeatureModel';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import ISpinData from '../../../vendor_core/core/src/server/data/ISpinData';
import { State } from '../../../vendor_core/core/src/states/State';
import { StateMachine } from '../../../vendor_core/core/src/states/StateMachine';
import BangUp from '../../../vendor_core/core/src/utils/BangUp';
import KeyboardManager, { Key } from '../../../vendor_core/core/src/utils/KeyboardManager';
import Layer from '../../../vendor_core/core/src/utils/Layer';
import Locale from '../../../vendor_core/core/src/utils/Locale';
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import BitmapTextField from '../../../vendor_core/core/src/views/components/BitmapTextField';
import TextField from '../../../vendor_core/core/src/views/components/TextField';
import SceneView from '../../../vendor_core/core/src/views/SceneView';
import SpineAnimation from '../../../vendor_core/core/src/views/SpineAnimation';

export default class BBBigWinState extends State {
    protected layer: Layer;
    protected spinModelProp: keyof ISpinData;
    protected bwBitmapText: BitmapTextField | TextField | PIXI.Text;
    protected scene: SceneView;
    protected currentBigWinLevel = 0;
    protected maxBigWinLevel = 0;
    protected bigWinScenes = [
        "BIG_WIN",
        "HUGE_WIN",
        "MEGA_WIN",
        "ELECTRIC_WIN"
    ];
    protected bitWinTexts = [
        "BIG   POPS",
        "HUGE   POPS",
        "MEGA   POPS",
        "STAR   POPS"
    ];
    protected bitWinMusicDurations = [];
    // protected bangUp: BangUp;
    protected bangUpVal: number = 0;
    protected _canExit = false;
    protected logoAnim: SpineAnimation;
    protected currentBangup: BangUp;
    protected delayedCall: TweenMax;
    protected fade: TweenMax;
    protected startStateDelay = 1;

    constructor(stateMachine: StateMachine, spinModelProp: keyof ISpinData = "winAmount") {
        super(stateMachine);
        this.spinModelProp = spinModelProp;
    }

    public enter(): void {
        this._canExit = false;
        super.enter();
        this.bitWinTexts = GameModel.gameConfig.bitWinTextsMap || this.bitWinTexts;
        this.bigWinScenes = GameModel.gameConfig.bigWinScenes || this.bigWinScenes;
        this.bitWinMusicDurations = GameModel.gameConfig.bigWinMusicStamps;

        this.setHighestWinLevel();

        TweenMax.delayedCall(this.startStateDelay, this.startState);

    }
    protected startState = () => {
        this.layer = ViewManager.getLayer("WinSplash");
        // this.backgroundLayer = ViewManager.getLayer("CelebrationBackground");
        this.layer.clear();
        this.scene = this.layer.setScene("win");
        this.scene.sceneTextFields.get("title").visible = false;
        this.scene.interactive = true;
        KeyboardManager.onKey("pressed", Key.SPACE, this.skipWithKey, this);
        this.scene.on(PointerEvents.DOWN, this.skipWithKey, this);

        this.playTransitionSound();
        this.startBigWin();
        // let coinAnim = ViewManager.getLayer("CoinAnim").setScene("open").spineAnimations.get("balloon_wild");
        let coinAnim = ViewManager.getLayer("CelebrationBackground").setScene("open").spineAnimations.get("balloon_wild");
        TweenMax.delayedCall(0.5, () => coinAnim.play("Win-full-anim", false, 0.9))
        // if (GameModel.gameConfig.playBigWinCoins) {
        //     this.startCoinAnimation();
        // }
    }

    protected onBigWinAnimationComplete() {
        // let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
        //     .getCurrentScene()
        //     .getSubView("ReelGroup") as BBReelGroup;
        this.currentBigWinLevel++;
        if (this.fade) {
            this.fade.kill();
        }
        // if (this.currentBigWinLevel > this.maxBigWinLevel) {
            // reelGroup.currentBigWinAnimation(this.bigWinScenes[this.currentBigWinLevel - 1], "end", 10, 0.6)
            // this.bigWinAnimation("end", this.bigWinScenes[this.currentBigWinLevel], 0.6)

        // }
        if (this.currentBigWinLevel <= this.maxBigWinLevel) {
            this.startBigWin()
        } else {
            this._canExit = false;
            SoundController.stopMusic();
            this.bwBitmapText.alpha = 0;
            this.bwBitmapText.text = Locale.getString(this.bitWinTexts[this.maxBigWinLevel]);
            this.bangUpVal = this.getSum();
            const winMoney = this.scene.sceneMoneyFields.get("win_counter");
            winMoney.value = this.bangUpVal;
            // ViewManager.getLayer("CoinAnim").clear();
            let coinAnim = ViewManager.getLayer("CelebrationBackground").setScene("open").spineAnimations.get("balloon_wild");
            coinAnim.stop(true);
            // let coinAnim = ViewManager.getLayer("CelebrationBackground").getCurrentScene().spineAnimations.get("balloon_wild");
            // coinAnim.stop(true);
            // this.fade = FadeOut(this.bwBitmapText, GameModel.gameConfig.bigWinEnd / 2, GameModel.gameConfig.bigWinEnd / 2);
            if (SpinModel.isInFreespins()) {
                SoundController.startMusic(SoundVars.MUSIC_BONUS);
            } else {
                SoundController.startMusic(SoundVars.MUSIC_MAIN);
            }
            SoundController.playSound('bigwin_start_lv1');

            this.delayedCall = TweenMax.delayedCall(3, () => {
                this.onBigWinComplete()
            });
        }

    }

    canExit() {
        return this._canExit;
    }

    skipWithKey() {
        if (this.canExit()) {
            this.skip();
        }
    }

    skip() {
        this.scene.off(PointerEvents.DOWN, this.skipWithKey, this);
        KeyboardManager.offKey("pressed", Key.SPACE, this.skipWithKey, this);
        this._canExit = false;
        if (this.delayedCall) {
            this.delayedCall.kill();
        }
        // this.coinAnim.play(``)
        this.currentBigWinLevel = this.maxBigWinLevel;
        // console.log(this.currentBigWinLevel);
        // debugger
        this.logoAnim.play(this.bigWinScenes[this.currentBigWinLevel], true);
        this.bwBitmapText.text = Locale.getString(this.bitWinTexts[this.maxBigWinLevel]);
        if (this.currentBangup.currentBangup == null) {
            this.onBigWinAnimationComplete();
        }
        this.currentBangup.clearBangup();
    }


    protected onBigWinComplete() {
        this._canExit = false;
        this.scene.off(PointerEvents.DOWN, this.skipWithKey, this);
        this.scene = null;
        this.currentBigWinLevel = 0;
        this.maxBigWinLevel = 0;
        this.bangUpVal = 0;
        this.layer.completeClear();
        // this.backgroundLayer.completeClear();
        KeyboardManager.offKey("pressed", Key.SPACE, this.skipWithKey, this);
        this.exit();
    }

    protected startBigWin() {

        this.bwBitmapText = this.scene.sceneTextFields.get("title");
        this.bwBitmapText.text = Locale.getString(this.bitWinTexts[this.currentBigWinLevel]);

        let animScene = ViewManager.getLayer("CelebrationBackground").getCurrentScene();
        if (!animScene) {
            animScene = ViewManager.getLayer("CelebrationBackground").setScene("open")
        }

        this.logoAnim = animScene.spineAnimations.get("bigwin_anim");
        this.logoAnim.play(this.bigWinScenes[this.currentBigWinLevel], true)

        const winMoney = this.scene.sceneMoneyFields.get("win_counter");
        winMoney.value = this.bangUpVal;
        // this.fade = FadeIn(this.bwBitmapText, 0.5)
        let bangupEndVal = this.getSum();
        this.currentBangup = new BangUp();
        let bigWinTimeline = new TimelineMax({ paused: false });

        // bigWinTimeline.add(() => {
        //     switch (this.currentBigWinLevel) {
        //         case 0:
        //             // SoundController.playSound('bigwin_start_lv1');
        //             // this.bigWinMusic.fade(0, 1, 1917);
        //             break;
        //         case 1:
        //             // SoundController.playSound('bigwin_start_lv2');
        //             // this.bigWinMusic.fade(0, 1, 1917);
        //             break;
        //         case 2:
        //             // SoundController.playSound('bigwin_start_lv3');
        //             // this.bigWinMusic.fade(0, 1, 1917);
        //             break;
        //         case 3:
        //             // SoundController.playSound('bigwin_start_lv4');
        //             // this.bigWinMusic.fade(0, 1, 1917);
        //             break;
        //     }

        //     // this.bigWinAnimation("start", this.bigWinScenes[this.currentBigWinLevel], 0.4, animScene)
        //     // reelGroup.currentBigWinAnimation(this.bigWinScenes[this.currentBigWinLevel], "start", 15, 0.4)

        // })
        bigWinTimeline.add(() => {
            this.currentBangup.startBangup(this.bangUpVal, bangupEndVal, this.bitWinMusicDurations[this.currentBigWinLevel], { ease: Power1.easeOut }, (val) => {
                this.bangUpVal = val;
                winMoney.value = this.bangUpVal;
            }, () => {
                this.onBigWinAnimationComplete();
            });
        })
        this._canExit = true;
    }

    playCollectSound() {
        // SoundController.stopMusic();
        SoundController.playSound("bigWinEnd");
    }

    playCounterCompleteSound() {
    }

    playTransitionSound() {
        SoundController.stopMusic();
        SoundController.playMusic("bigWinMusic", 0);
    }

    protected getSum(): number {
        let bangupEndVal = 0;
        if (this.maxBigWinLevel > this.currentBigWinLevel) {
            let bet = BetModel.totalBet;
            if (BuyFeatureModel.isInBuyFeatureFreeSpins) {
                bet = BuyFeatureModel.getBet();
            }
            bangupEndVal = GameModel.gameConfig.bigWinRatioLevels[this.currentBigWinLevel] * bet;
        } else {
            bangupEndVal = SpinModel["currentWin"];
        }
        return bangupEndVal;
    }

    protected setHighestWinLevel() {
        const bigWinRatios = GameModel.gameConfig.bigWinRatioLevels;
        let bet = BetModel.totalBet;
        if (BuyFeatureModel.isInBuyFeatureFreeSpins) {
            bet = BuyFeatureModel.getBet();
        }
        const currentWinRatio = SpinModel.currentWin / bet;
        for (let i = bigWinRatios.length - 1; i > 0; i--) {
            if (bigWinRatios[i] <= currentWinRatio) {
                this.maxBigWinLevel = i;
                break;
            }
        }
    }

    exit() {
        // let anim = ViewManager.getLayer("CelebrationBackground").getCurrentScene().spineAnimations.get("popup_win");
        ViewManager.getLayer("CelebrationBackground").getCurrentScene().spineAnimations.get("bigwin_anim").stop(true);
        // anim.playAsync(`outro_${this.bigWinScenes[this.currentBigWinLevel].toLowerCase()}`).then(() => {
            ViewManager.getLayer("CelebrationBackground").clear()
            // anim.stop(true)
            super.exit();
        // })
        // anim.stop(true);
        // if (SpinModel.isInFreespins()) {
        //     SoundController.playMusic(SoundVars.MUSIC_BONUS);
        // } else {
        //     SoundController.playMusic(SoundVars.MUSIC_MAIN);
        // }
        // anims.forEach(anim => {
        //     anim.stop()
        // })



    }
}
